export const height = 500
export const divCoefficient = 1 / 483 * 644
export const width = height * divCoefficient